import Component from 'core/Component';
import { Event } from 'services/EventEmitter';
import { deepMerge } from 'toolbox/deepMerge';
import { mix } from 'core/mixwith';
import LoaderMixin from 'mixins/Loader';

/**
 * This is a description of the SearchGrid constructor function.
 * @class
 * @classdesc This is a description of the SearchGrid class.
 * @extends Component
 */
export default class SearchGrid extends mix(Component).with(LoaderMixin) {
    /**
     * Constructor of the class that mainly merge the options of the components
     *
     * @param {HTMLElement} element HTMLElement of the component
     * @param {Object} options That belongs to the component
     */
    constructor(element, options = {}) {
        super(element, deepMerge({
            templateName: 'search/searchgrid',
            dataModelId: 'searchgrid',
        }, options));
    }

    /**
     * All selectors must be cached. Never cache elements that are out of the component scope
     */
    initCache() {
        this.observer = null;
        this.tileTimeout = null;
        this.loader = null;
    }

    /**
     * Should contain only event listeners and nothing else
     * All the event handlers should be into a separated function. No usage of anonymous function
     */
    bindEvents() {
        Event.on('search.update', this.onSearchUpdate, this);
        Event.on('search.updated', this.onSearchUpdated, this);
        Event.on('search.removeLoader', this.onSearchRemoveLoader, this);
    }

    /**
     * Search Update event handler
     *
     * @param {Object} data  Data due to refinement to be changed
     * @param {Boolean} isInsertMode Flag due to a insertion
     */
    onSearchUpdate(data, isInsertMode) {
        if (!isInsertMode) {
            this.addLoader(null, { overlay: true });
        }
    }

    /**
     * Search Updated event handler
     *
     * @param {Object} data Data due to refinement to be changed
     * @param {Boolean} isInsertMode Flag due to a insertion
     */
    onSearchUpdated(data, isInsertMode) {
        if (data[this.options.dataModelId]) {
            this.render(data[this.options.dataModelId], {
                replaceChildren: true,
                isAppend: !!isInsertMode,
            }).then(() => {
                this.removeLoader();
            });
        } else {
            this.removeLoader();
        }
    }

    /**
     * Remove Loader when search fails
     */
    onSearchRemoveLoader() {
        this.removeLoader();
    }

    /**
     * Destroy is called automatically after the component is being removed from the DOM
     * You must always destroy the listeners attached to an element to avoid any memory leaks
     */
    destroy() {
        Event.removeListener('search.update', this.onSearchUpdate, this);
        Event.removeListener('search.updated', this.onSearchUpdated, this);
        Event.removeListener('search.removeLoader', this.onSearchRemoveLoader, this);
    }
}
